<template>
  <div class="header wow animate__backInUp"
       data-wow-duration="1s">
    <div class="warp">
      <div class="logo">
        <img src="@/assets/images/logo.png" />
      </div>
      <div class="nav">
        <ul>
          <li v-for="item in link"
              @click.stop="liClick(item.id)"
              :key='item.url'
              :class="{active:path.indexOf(item.url)>=0}">

            <router-link v-if="item.id==1||item.id==5||item.id==6"
                         :to='item.url'>{{item.text}}</router-link>
            <a class="sjrz1"
               v-else-if="item.id==4">
              {{item.text}}
              <div class="select">
                <p @click.stop="gorz">立即入驻</p>
                <p @click="goadmin">商家登录</p>
              </div>
            </a>
            <a v-else
               target="_blank"
               :href='item.url'>{{item.text}}</a>
            <img v-if="path.indexOf(item.url)>=0&&item.id==4"
                 src="../../assets/images/index/in.png" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
import { mapActions, mapGetters, mapMutations } from "vuex"
import config from '@/assets/config.json';
export default {
  name: 'headers',
  data () {
    return {
      link: [
        {
          id: 1,
          url: '/Page/Index',
          text: '首页'
        },
     /*    {
          id: 2,
          url: 'http://shop.9buqi.com',
          text: '商城'
        }, */
        // {
        //     id:3,
        //     url:'https://old.9buqi.com',
        //     text:'九不欺活米'
        // },
        {
          id: 4,
          url: '/Page/settlepro',
          text: '登录/入驻'
        },
        {
          id: 5,
          url: '/Page/about',
          text: '关于我们'
        },
        /* {
          id: 6,
          url: '/Page/OAIndex',
          text: 'OA登录/入驻'
        } */
      ],
      isac: false,
      isRz: false,
      path: '/Page/Index'
    }
  },
  created () {
    //  console.log(this.login)
  },
  mounted () {
    this.$nextTick(() => {
      let wow = new WOW({
        live: false
      })
      wow.init()
    })
    let body = document.getElementsByTagName('body')[0];
    body.onclick = () => {
      this.isRz = false;
    }
  },
  computed: {
    ...mapGetters({
      login: 'getLogin'
    })
  },
  methods: {
    liClick (id) {
      console.log(id);
      this.isac = false;
      this.isRz = false;
      if (id == 4) {
        this.isac = !this.isac;
        this.isRz = true;
      } else {

      }
    },
    gorz () {
      this.isRz = false;
      if (this.$route.path != '/Page/settlepro')
        this.$router.push('/Page/settlepro');
    },
    goadmin () {
      //https://www.9buqi.com/business/login
          window.open(config.admin);
    }
  },
  watch: {
    '$route': {
      handler (val, oldVal) {
        this.path = val.path;
        console.log('val的值===>>>',val);
        
      },
      immediate:true,
      deep: true //true 深度监听
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  max-width: 1920px;
  width: 100%;
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  right: 0;
  font-size: 16px;
  color: #333;
  height: 100px;
  background: #fff;
  .logo {
    width: 8%;
  }
  .warp {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .nav {
    ul {
      display: flex;
      li {
        margin-right: 80px;
        cursor: pointer;
        display: flex;
        align-items: center;
        img {
          width: 18px;
          margin-left: 3px;
          height: 18px;
        }
        a {
          color: #333;
          font-size: 16px;
          display: inline-block;
          font-weight: bold;
          height: 100px;
          line-height: 100px;
        }
        a::after {
          content: "";
          position: absolute;
          width: 80%;
          height: 0;
          left: 50%;
          transform: translateX(-50%);
          bottom: 30px;
          background: #e60012;
        }
        &:last-child {
          margin-right: 0;
        }
        a:hover {
          color: #e60012;
          position: relative;
          &::after {
            height: 2px;
          }
        }
        // .sjrz1{

        // }
        .sjrz1 {
          //   color: #E60012;
          //   position: relative;
          //   &::after{
          //     height: 2px;
          //   }
          &:hover {
            .select {
              display: block;
            }
          }
          .select {
            display: none;
            background: #fff;
            width: 240px;
            text-align: center;
            position: absolute;
            margin-left: -77px;
            p {
              font-size: 16px;
              color: #333333;
              border-top: 1px solid #dddddd;
              height: 60px;
              line-height: 60px;
              &:hover {
                color: #ed4c59;
              }
            }
          }
        }
      }
      .active {
        a {
          color: #e60012;
          position: relative;
        }
        a::after {
          height: 2px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue